import Images from '../../../../Configs/images';

const styles = {
  root: {
    height: '100vh',
    boxSizing: 'border-box',
  },
  linearSection: {
    paddingTop: 16,
    paddingBottom: 24,
    backgroundImage: `url(${Images.BottleLayer})`,
    backgroundRepeat: 'no-repeat',
    boxSizing: 'border-box',
    backgroundSize: 'cover',
    zIndex: 1,
  },
};

export default styles;
